var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ModelSync } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BFormSelect, BFormInput, BInputGroup, BInputGroupAppend, BButton, BFormSelectOption, BOverlay } from 'bootstrap-vue';
import axios from 'axios';
let MouldingSearchFilters = class MouldingSearchFilters extends Vue {
    filterObject;
    loading = true;
    colours = [];
    profiles = [];
    widthOptions = [
        { value: '10-25', text: '10mm - 25mm' },
        { value: '26-50', text: '26mm - 50mm' },
        { value: '51-75', text: '51mm - 75mm' },
        { value: '76-999', text: '76mm+' },
    ];
    depthOptions = [
        { value: '1-14', text: '<15mm' },
        { value: '15-25', text: '15mm - 25mm' },
        { value: '26-50', text: '26mm - 50mm' },
        { value: '51-999', text: '51mm+' }
    ];
    rebateDepthOptions = [
        { value: '1-10', text: '<10mm' },
        { value: '11-15', text: '10mm - 15mm' },
        { value: '16-30', text: '16mm - 30mm' },
        { value: '31-999', text: '30mm+' }
    ];
    priceOptions = [
        { value: 'budget', text: 'Budget' },
        { value: 'standard', text: 'Standard' },
        { value: 'premium', text: 'Premium' }
    ];
    sortByOptions = [
        { value: 'favourites', text: 'Favourites' },
        { value: 'price', text: 'Price' },
        { value: 'width', text: 'Width' },
        { value: 'depth', text: 'Depth' },
        { value: 'rebate_depth', text: 'Rebate Depth' },
    ];
    orderOptions = [
        { value: 'asc', text: 'Ascending' },
        { value: 'desc', text: 'Descending' }
    ];
    get colourOptions() {
        return this.colours.map(colour => ({
            value: colour.id,
            text: colour.name
        }));
    }
    get profileOptions() {
        return this.profiles.map(profile => ({
            value: profile.id,
            text: profile.name
        }));
    }
    async mounted() {
        // Get the possible profiles and colours
        await Promise.all([
            axios.get('/api/materials/moulding/colours')
                .then(result => this.colours = result.data),
            axios.get('/api/materials/moulding/profiles')
                .then(result => this.profiles = result.data)
        ]);
        this.loading = false;
    }
};
__decorate([
    ModelSync('filter', 'change', { type: Object })
], MouldingSearchFilters.prototype, "filterObject", void 0);
MouldingSearchFilters = __decorate([
    Component({
        components: {
            BRow, BCol, BFormGroup, BFormSelect, BFormInput, BInputGroup, BInputGroupAppend, BButton, BFormSelectOption, BOverlay
        }
    })
], MouldingSearchFilters);
export default MouldingSearchFilters;
